module.exports = __webpack_public_path__ + "static/tree-d2b5ad99933a65f8400b1e17f38b47a2.jpg";